<template>
  <div class="ll-contact-list">
    <div class="input-item">
      <div class="title-line">
        <p class="input-title">
          {{ $t('聯絡人') }}<span>*</span>
        </p>
        <WsTextButton001
          leading-icon="icon-add"
          font-size-xs
          no-padding
          @click="$_addMemberClick()"
        >
          {{ $t('新增聯絡人') }}
        </WsTextButton001>
      </div>
      <div
        v-for="(item, item_k) in _value"
        :key="'value'+ item_k"
        class="ll-contact-list-item"
      >
        <div class="title-line">
          <p class="input-title">
            {{ $t('聯絡人')+ (item_k + 1) }}
          </p>
          <WsTextButton001
            v-if="_value.length!==1"
            leading-icon="icon-delete"
            red
            font-size-xs
            no-padding
            @click="$_deletePopupOpen(_value,item_k)"
          >
            {{ $t('刪除') }}
          </WsTextButton001>
        </div>
        <div class="input-item">
          <StateInputButton
            v-model="_value[item_k].name"
            :title="$t('姓名')"
            :placeholder="$t('輸入')"
          />
        </div>
        <div class="input-item">
          <StateInputButton
            v-model="_value[item_k].email"
            :title="$t('信箱')"
            :placeholder="$t('輸入')"
          />
        </div>
        <div class="input-item">
          <StateInputButton
            v-model="_value[item_k].tel"
            :title="$t('電話')"
            :placeholder="$t('輸入')"
          />
        </div>
        <div class="input-item">
          <StateInputButton
            v-model="_value[item_k].mobile"
            :title="$t('手機')"
            :placeholder="$t('輸入')"
          />
        </div>
      </div>
    </div>
    <PopUp
      :pop-up-active="deletePopupActive"
      :title="$t('確定要刪除此聯絡人嗎？')"
      @click="$_deletePopupClose()"
    >
      <LlCancelPopupContent>
        <template v-slot:buttons>
          <WsButton001
            out-line
            @click="$_deletePopupClose()"
          >
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_deleteClick(deleteQuesList, deleteQuesIndex)">
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
  </div>
</template>
<script>
export default {
  name: "LlContactList",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      deletePopupActive: false,
      deleteQuesList: [],
      deleteQuesIndex: 0,
    };
  },
  computed:{
    _value() {
      return this.value? this.value : []
    }
  },
  methods: {
    $_addMemberClick() {
      this._value.push({
        name: "",
        email: "",
        tel: "",
        mobile: "",
      });
      this.$emit("add-click");
      this.$emit("input", this._value)
    },
    $_deletePopupOpen(value, index) {
      this.deletePopupActive = true;
      this.deleteQuesList = value;
      this.deleteQuesIndex = index;
    },
    $_deletePopupClose() {
      this.deletePopupActive = false;
      this.deleteQuesList = [];
      this.deleteQuesIndex = 0;
    },
    $_deleteClick(value, index) {
      value.splice(index, 1);
      this.$emit("delete-click", value);
      this.$_deletePopupClose();
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-contact-list";
</style>